/**
 * @type {Boolean}
 */
export const isAnonymous = Boolean(window.IsAnonymous);

/**
 * @type {Boolean}
 */
export const isSubscriber = Boolean(window.IsSubscriber);
